import { IClientConfig } from "../definitions";
import { FlowConfig, getFlowConfig } from "./flows";


export const CLIENT_CONFIG: IClientConfig = {
    flows: FlowConfig,
    getFlowConfig
}